/**
 * Cart animation for sections/new-toolbar-mobile.liquid only.
 * Loaded by that section. No-ops when the toolbar is not in the DOM.
 * Listens to the existing cart:change / cart:refresh events; does not add to cart.
 */
(function () {
  "use strict";

  if (window.__newToolbarMobileInit) return;
  window.__newToolbarMobileInit = true;

  var ROOT = "[data-new-toolbar-mobile]";
  var CART = ".new-toolbar-mobile__cart";
  var TARGET = "[data-new-toolbar-cart-target]";
  var mobileQuery = window.matchMedia("(max-width: 1149px)");
  var reducedMotionQuery = window.matchMedia("(prefers-reduced-motion: reduce)");

  var fillSeq = 0;
  var fillTimer = null;
  var fillManyTimer = null;
  var tooltipTimer = null;
  var tooltipIdleTimer = null;
  var TOOLTIP_VISIBLE_MS = 3000;
  var TOOLTIP_IDLE_DELAY_MS = 2000;
  var DEFAULT_TOOLTIP_TEXT = "Item added to your cart";
  var CART_COUNT_TOOLTIP_SESSION_KEY = "newToolbarCartCountTooltipShown";
  var previousCart = null;
  var previousCount = null;
  var lastSourceImage = null;
  var fillPlaying = false;

  function rootEl() {
    return document.querySelector(ROOT) || document.querySelector("[data-new-toolbar-cart-host]");
  }

  function carts() {
    return document.querySelectorAll(CART);
  }

  function cartTarget() {
    var root = rootEl();
    if (!root) return null;
    var node = root.querySelector(TARGET);
    if (!node) return null;
    var rect = node.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return node;
  }

  function syncCount(itemCount) {
    var hasItems = (itemCount || 0) > 0;
    carts().forEach(function (cartEl) {
      var countEl = cartEl.querySelector("hdt-cart-count");
      if (countEl) countEl.classList.toggle("is-hidden", !hasItems);
    });
  }

  function setResting(itemCount) {
    carts().forEach(function (cartEl) {
      cartEl.classList.remove("is-fill-one");
      cartEl.classList.toggle("is-fill-many", itemCount >= 1);
    });
    syncCount(itemCount);
  }

  function restartClass(cartEl, className) {
    cartEl.classList.remove(className);
    void cartEl.offsetWidth;
    cartEl.classList.add(className);
  }

  function tooltipEls() {
    return document.querySelectorAll("[data-new-toolbar-tooltip]");
  }

  function setTooltipText(text) {
    tooltipEls().forEach(function (tip) {
      tip.textContent = text;
    });
  }

  function openTooltips() {
    var tips = tooltipEls();
    if (!tips.length) return;
    tips.forEach(function (tip) {
      tip.classList.remove("is-open");
      void tip.offsetWidth;
      tip.classList.add("is-open");
    });
    clearTimeout(tooltipTimer);
    tooltipTimer = setTimeout(function () {
      tips.forEach(function (tip) {
        tip.classList.remove("is-open");
        tip.textContent = DEFAULT_TOOLTIP_TEXT;
      });
    }, TOOLTIP_VISIBLE_MS);
  }

  function showAddedTooltip() {
    setTooltipText(DEFAULT_TOOLTIP_TEXT);
    openTooltips();
  }

  function cartCountMessage(count) {
    var n = Number(count) || 0;
    return n + (n === 1 ? " item in your cart" : " items in your cart");
  }

  function cartCountNow() {
    if (previousCount != null) return previousCount;
    var root = rootEl();
    if (!root) return 0;
    var countEl = root.querySelector("hdt-cart-count");
    var parsed = countEl ? parseInt(String(countEl.textContent || "").trim(), 10) : NaN;
    return Number.isFinite(parsed) ? parsed : 0;
  }

  function cartCountTooltipShown() {
    try {
      return sessionStorage.getItem(CART_COUNT_TOOLTIP_SESSION_KEY) === "1";
    } catch (e) {
      return false;
    }
  }

  function markCartCountTooltipShown() {
    try {
      sessionStorage.setItem(CART_COUNT_TOOLTIP_SESSION_KEY, "1");
    } catch (e) {}
  }

  function scheduleIdleTooltip() {
    if (cartCountTooltipShown()) return;
    clearTimeout(tooltipIdleTimer);
    tooltipIdleTimer = setTimeout(function () {
      tooltipIdleTimer = null;
      if (cartCountTooltipShown()) return;
      if (!rootEl() || cartCountNow() < 1) return;
      if (document.querySelector("[data-new-toolbar-tooltip].is-open")) return;
      setTooltipText(cartCountMessage(cartCountNow()));
      openTooltips();
      markCartCountTooltipShown();
    }, TOOLTIP_IDLE_DELAY_MS);
  }

  function playFill(itemCount) {
    if (!carts().length || itemCount < 1) {
      fillPlaying = false;
      setResting(itemCount);
      return;
    }

    var seq = ++fillSeq;
    fillPlaying = true;
    clearTimeout(fillTimer);
    clearTimeout(fillManyTimer);
    syncCount(itemCount);
    showAddedTooltip();

    carts().forEach(function (cartEl) {
      cartEl.classList.remove("is-fill-one", "is-fill-many");
    });

    fillTimer = setTimeout(function () {
      if (seq !== fillSeq || !rootEl()) return;
      carts().forEach(function (cartEl) {
        restartClass(cartEl, "is-fill-one");
      });
      fillManyTimer = setTimeout(function () {
        if (seq !== fillSeq || !rootEl()) return;
        carts().forEach(function (cartEl) {
          restartClass(cartEl, "is-fill-many");
        });
        fillPlaying = false;
      }, 800);
    }, 300);
  }

  function itemImage(item) {
    if (!item) return "";
    var src = "";
    if (typeof item.image === "string") src = item.image;
    else if (item.image && (item.image.src || item.image.url)) src = item.image.src || item.image.url;
    else if (item.featured_image) src = item.featured_image.url || item.featured_image.src || "";
    if (src.indexOf("//") === 0) src = "https:" + src;
    return src;
  }

  function itemIdentity(item) {
    return String((item && (item.key || item.variant_id || item.id)) || "");
  }

  function changedItem(currentCart, direction) {
    if (!currentCart || !Array.isArray(currentCart.items)) return null;
    if (!previousCart || !Array.isArray(previousCart.items)) return currentCart.items[0] || null;

    var currentById = new Map(
      currentCart.items.map(function (item) {
        return [itemIdentity(item), Number(item.quantity) || 0];
      })
    );
    var previousById = new Map(
      previousCart.items.map(function (item) {
        return [itemIdentity(item), Number(item.quantity) || 0];
      })
    );
    var candidates = direction === "add" ? currentCart.items : previousCart.items;
    return (
      candidates.find(function (item) {
        var id = itemIdentity(item);
        var before = previousById.get(id) || 0;
        var after = currentById.get(id) || 0;
        return direction === "add" ? after > before : after < before;
      }) ||
      candidates[0] ||
      null
    );
  }

  function sourceImageFrom(element) {
    if (!element || !element.closest) return null;
    var product = element.closest(
      "hdt-card-product, .hdt-card-product, [data-product-id], .cart-item, [data-cart-item]"
    );
    if (!product) return null;
    return product.querySelector(".hdt-card-product__media--main, [update-img], img");
  }

  function imageCenter(image) {
    if (!image || !image.isConnected) return null;
    var rect = image.getBoundingClientRect();
    if (!rect.width || !rect.height) return null;
    return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
  }

  function animateProduct(imageUrl, direction) {
    var target = cartTarget();
    if (!target) return;

    target.classList.remove("is-pulse");
    void target.offsetWidth;
    target.classList.add("is-pulse");

    if (reducedMotionQuery.matches || !imageUrl) return;

    var targetRect = target.getBoundingClientRect();
    var targetCenter = {
      x: targetRect.left + targetRect.width / 2,
      y: targetRect.top + targetRect.height / 2,
    };
    var sourceCenter = imageCenter(lastSourceImage);
    var fallback = { x: (window.innerWidth * 3) / 8, y: (window.innerHeight * 3) / 8 };
    var start = direction === "add" ? sourceCenter || fallback : targetCenter;
    var end = direction === "add" ? targetCenter : sourceCenter || fallback;

    var flyer = document.createElement("img");
    flyer.className = "new-toolbar-mobile-flyer new-toolbar-mobile-flyer--" + direction;
    flyer.src = imageUrl;
    flyer.alt = "";
    flyer.setAttribute("aria-hidden", "true");
    flyer.style.setProperty("--fly-start-x", start.x + "px");
    flyer.style.setProperty("--fly-start-y", start.y + "px");
    flyer.style.setProperty("--fly-end-x", end.x + "px");
    flyer.style.setProperty("--fly-end-y", end.y + "px");
    document.body.appendChild(flyer);
    flyer.addEventListener("animationend", function () { flyer.remove(); }, { once: true });
  }

  function handleCart(cart, event) {
    if (!rootEl() || !cart) return;

    var count = Number(cart.item_count);
    if (!Number.isFinite(count)) return;

    var baseEvent = event && event.detail && event.detail.baseEvent;
    var increased = previousCount != null && count > previousCount;
    var isAdd =
      increased ||
      (previousCount === null &&
        (baseEvent === "variant:add" || baseEvent === "line-item:change" || baseEvent === "qty_control:add"));

    if (previousCount === null && !isAdd) {
      previousCount = count;
      previousCart = cart;
      syncCount(count);
      return;
    }

    if (mobileQuery.matches && cartTarget() && previousCount != null && count !== previousCount) {
      var direction = count > previousCount ? "add" : "remove";
      var item = changedItem(cart, direction);
      var imageUrl = itemImage(item);
      if (!imageUrl && lastSourceImage) imageUrl = lastSourceImage.currentSrc || lastSourceImage.src || "";
      animateProduct(imageUrl, direction);
    }

    if (isAdd && count > 0) playFill(count);
    else if (!fillPlaying || count < 1) setResting(count);

    previousCount = count;
    previousCart = cart;
    lastSourceImage = null;
  }

  document.addEventListener(
    "pointerdown",
    function (event) {
      if (!rootEl()) return;
      lastSourceImage = sourceImageFrom(event.target);
    },
    true
  );

  document.addEventListener("cart:change", function (event) {
    handleCart(event && event.detail && event.detail.cart, event);
  });

  document.addEventListener("cart:refresh", function (event) {
    if (!rootEl()) return;
    var cart = event && event.detail && event.detail.cart;
    if (cart) {
      handleCart(cart, event);
      return;
    }
    fetch("/cart.js?t=" + Date.now(), { cache: "no-store" })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (cartData) { if (cartData) handleCart(cartData, event); })
      .catch(function () {});
  });

  document.addEventListener("shopify:section:unload", function (event) {
    var target = event && event.target;
    if (!target || !target.querySelector) return;
    if (!target.querySelector(ROOT) && !target.querySelector("[data-new-toolbar-cart-host]")) return;
    clearTimeout(fillTimer);
    clearTimeout(fillManyTimer);
    clearTimeout(tooltipTimer);
    clearTimeout(tooltipIdleTimer);
    document.querySelectorAll(".new-toolbar-mobile-flyer").forEach(function (node) {
      node.remove();
    });
  });

  function seed() {
    var root = rootEl();
    if (!root || previousCount !== null) return;
    var countEl = root.querySelector("hdt-cart-count");
    var parsed = countEl ? parseInt(String(countEl.textContent || "").trim(), 10) : NaN;
    if (!Number.isFinite(parsed)) return;
    previousCount = parsed;
    syncCount(parsed);
  }

  function start() {
    seed();
    scheduleIdleTooltip();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
